import { RefObject, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { RTL_LANGUAGES } from 'constants/index';

const SMALL_SCREEN_END = 375;
const SIDE_PADDING = '30px';
const SMALL_SIDE_PADDING = '20px';

function useSidePaddingsOnHorizontalScroll(ref: RefObject<any>) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const container = ref.current;
    const rtl = RTL_LANGUAGES.includes(i18n.language);
    const margin = rtl ? 'marginRight' : 'marginLeft';
    const padding = rtl ? 'paddingRight' : 'paddingLeft';

    const handleScroll = () => {
      const scrollX = ref.current?.scrollLeft || 0;

      if (container) {
        // Should multiple with -1 because scroll is opposite in the RTL mode.
        if (scrollX * (rtl ? -1 : 1)  > 0) {
          container.style[margin] = 'unset';
          container.style[padding] = window.innerWidth > SMALL_SCREEN_END ? SIDE_PADDING : SMALL_SIDE_PADDING;
        } else {
          container.style[margin] = window.innerWidth > SMALL_SCREEN_END ? SIDE_PADDING : SMALL_SIDE_PADDING;
          container.style[padding] = 'unset';
        }
      }
    };

    container?.addEventListener('scroll', handleScroll);

    return () => container?.removeEventListener('scroll', handleScroll);
  }, [i18n, ref]);
}

export default useSidePaddingsOnHorizontalScroll;
